import { useEffect, useRef, useState } from "react";

export default function CtaSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative py-16 md:py-24 px-4 md:px-8 lg:px-12 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('../../../../images/68b35d105aa049186d7159e2f57f8f0a.png')",
        }}
      />
      <div className="absolute inset-0 bg-black/60" />
      <div
        ref={ref}
        className={`relative z-10 w-full max-w-4xl mx-auto text-center transition-all duration-700 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <h2 className="font-bold text-3xl md:text-4xl lg:text-5xl text-white mb-4 drop-shadow-lg">
          Start Your Collection Today
        </h2>
        <p className="text-lg md:text-xl text-white/80 mb-8 max-w-2xl mx-auto drop-shadow-md">
          Every adventure with Cappy and Barry brings a smile and a lesson. Grab
          the whole series on Gumroad.
        </p>
        <a
          href="https://cappybarry.gumroad.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-white text-accent-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-accent-100 hover:text-accent-700 transition-colors whitespace-nowrap"
        >
          Visit the Gumroad Store
          <i className="ri-external-link-line" />
        </a>
        <p className="text-sm text-white/70 mt-4 drop-shadow">
          Available as digital downloads and print editions
        </p>
      </div>
    </section>
  );
}